<script setup lang="ts">
const model = defineModel<boolean>({ default: false })
</script>

<template>
  <div class="flex items-center gap-xs">
    <span class="text-xsmall nav:text-small select-none dark:text-carbon-50">Mørk<span class="hidden md:inline"> modus</span></span>
    <FormSwitch
      v-model="model"
      name="reading-dark-mode"
      label="mørk modus"
      aria-label="Mørk modus"
    />
  </div>
</template>
